<template>
  <v-dialog v-model="dialog" persistent width="400px">
    <template v-slot:activator="{ on }">
      <v-tooltip top v-on="on">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" small text v-on="on" @click="dialog = true"
            ><v-icon small>mdi-file-export-outline</v-icon>
          </v-btn>
        </template>
        <span>Export To Csv</span>
      </v-tooltip>
    </template>

    <v-card>
      <validation-observer v-slot="{ invalid }" ref="form">
        <v-card-title>Export Appointments</v-card-title>
        <v-card-text>
          <date-picker
            :value="startDate"
            :field="{ label: 'From' }"
            @fieldChange="startDate = $event"
            :validations="{ required: true }"
          ></date-picker>
          <v-spacer class="my-4"></v-spacer>
          <date-picker
            :value="endDate"
            :field="{ label: 'To' }"
            @fieldChange="endDate = $event"
            :validations="{ required: true }"
          ></date-picker>
          <v-spacer class="my-4"></v-spacer>
          <v-select
            v-model="selectedStatuses"
            label="Statuses"
            :items="statuses"
            multiple
            small-chips
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text :disabled="loading" @click="clear">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            outlined
            :dark="!invalid && !loading"
            :disabled="invalid || loading"
            @click="exportAppointments"
            >Download
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import { downloadFile } from "../../utils/download-utils";
import { formatDateForFilename } from "../../utils/format-utils";
export default {
  data() {
    return {
      dialog: false,
      startDate: "",
      endDate: "",
      selectedStatuses: [],
      loading: false,
    };
  },
  computed: {
    statuses() {
      return this.$store.state.optionsModule.statuses;
    },
    fileName() {
      return `IDEP Appointments ${formatDateForFilename(
        this.startDate
      )} to ${formatDateForFilename(this.endDate)}.csv`;
    },
  },
  methods: {
    async exportAppointments() {
      this.loading = true;
      var response = await this.$store.dispatch(
        "appointmentsModule/exportAppointments",
        {
          start: this.startDate,
          end: this.endDate,
          statuses: this.selectedStatuses.join(","),
        }
      );
      if (response) {
        await downloadFile(response, this.fileName);
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Oops! Something went wrong. Please try again later."
        );
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.loading = false;
      this.clear();
    },
    clear() {
      this.$refs.form.reset();
      this.dialog = false;
      this.startDate = "";
      this.endDate = "";
      this.selectedStatuses = [];
    },
  },
};
</script>
